import { jwtDecode } from "jwt-decode";
import { closeSnackbar } from 'notistack';
import { DecryptJweToken } from "./EncDecService";
import { RefreshApi } from "./apiService";
import { AuthApi } from "../apis/authapi";
import { showNotification } from "./notification";
import { sessionDataDec, sessionDataEnc } from "./sessionServiceEndDec";

let allowRefresh = true;
let isLoggingOut = false;

export const resetAutoLogoutState = () => {
    isLoggingOut = false;
};

export const checkTokenExpiry = async () => {
    try {
        const token = sessionDataDec("token");
        if (!token) {
            await autoLogOut();
            return false;
        }

        const jweToken = await DecryptJweToken(token);
        const decoded = jwtDecode(jweToken);
        const exp = decoded.exp * 1000;
        const now = Date.now();
        const remainingMs = exp - now;
        const mins = Math.floor(remainingMs / (1000 * 60));
console.log(mins);

        // ⏳ Refresh token if expiring soon (within 10 mins)
        if (allowRefresh && mins <= 10 && mins >= 1) {
            await refreshToken();
            return true;
        }

        // ⛔ Token expired
        if (exp <= now) {
            await autoLogOut();
            return false;
        }

        return true;
    } catch (err) {
        await autoLogOut();
        return false;
    }
};

// ==============================|| TOKEN REFRESH ||============================== //
export const refreshToken = async () => {
    allowRefresh = false;

    try {
        const refresh_token = sessionDataDec("refresh_token");
        if (!refresh_token) {
            await autoLogOut();
            return;
        }

        const params = new URLSearchParams();
        params.set("grant_type", "refresh_token");
        params.set("refresh_token", refresh_token);

        const res = await RefreshApi(AuthApi.url.login, params.toString());

        if (res?.access_token && res?.refresh_token) {
            sessionDataEnc("token", res.access_token);
            sessionDataEnc("refresh_token", res.refresh_token);
        } else {
            throw new Error("Invalid refresh response");
        }
    } catch (error) {
        await autoLogOut();
    } finally {
        allowRefresh = true;
    }
};

// ==============================|| AUTO LOGOUT ||============================== //
export const autoLogOut = async () => {
    if (isLoggingOut) return;
    isLoggingOut = true;

    sessionStorage.clear();
    closeSnackbar();
    showNotification("Session Timeout, Login Again", 'error');
    setTimeout(() => {
        window.location.href = "/";
    }, 1000);
};